import { useEffect, useRef, useState } from "react";
import { subscribe } from "../../lib/hyperliquid";
import { formatPrice } from "../../lib/format";

export default function TradeTape({ coin }) {
    const [trades, setTrades] = useState([]);
    const flashRef = useRef(0);

    useEffect(() => {
        if (!coin) return;
        setTrades([]);
        const unsub = subscribe({ type: "trades", coin }, (data) => {
            if (!Array.isArray(data)) return;
            const fresh = data.map((t) => ({
                id: `${t.tid || (t.time + "" + t.px + "" + t.sz)}`,
                side: t.side,            // "B" or "A"
                px: +t.px,
                sz: +t.sz,
                time: t.time,
                flashKey: ++flashRef.current,
            }));
            setTrades((prev) => [...fresh.reverse(), ...prev].slice(0, 36));
        });
        return unsub;
    }, [coin]);

    return (
        <div className="bg-[#0A0A0C] border border-[#1F1F24] rounded-sm flex flex-col" data-testid="trade-tape">
            <div className="px-4 py-3 border-b border-[#1F1F24]">
                <div className="text-[10px] font-mono uppercase tracking-[0.22em] text-zinc-500">Trade Tape</div>
                <div className="text-sm font-medium font-mono tracking-tight mt-0.5">Real-time prints</div>
            </div>
            <div className="grid grid-cols-3 px-3 py-1.5 text-[9px] font-mono uppercase tracking-[0.18em] text-zinc-500 border-b border-[#1F1F24]">
                <span>Price</span>
                <span className="text-right">Size</span>
                <span className="text-right">Time</span>
            </div>
            <div className="overflow-y-auto max-h-[280px]">
                {trades.length === 0 && (
                    <div className="px-3 py-6 text-center text-[11px] font-mono text-zinc-600">awaiting prints…</div>
                )}
                {trades.map((t) => (
                    <div
                        key={`${t.id}-${t.flashKey}`}
                        className={`grid grid-cols-3 px-3 py-[3px] text-[11px] font-mono ${
                            t.side === "B" ? "text-emerald-400 flash-up" : "text-rose-400 flash-down"
                        }`}
                    >
                        <span>{formatPrice(t.px)}</span>
                        <span className="text-right text-zinc-300">{t.sz.toFixed(4)}</span>
                        <span className="text-right text-zinc-500">{new Date(t.time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}
